import uris from './uris'
import axios from './axiosWrapper'

export default {
  getToken () {
    return localStorage.token || ''
  },
  logOut () {
    delete localStorage.token
  },
  isLoggedIn () {
    return !!localStorage.token
  },
  login (options) {
    /*
      options: {
        context: Vue,
        creds: {user: "", password: ""}
        onSuccess()
        onError()
      }
    */

    axios.post(uris.URL_LOGIN, options.creds)
      .then((data) => {
        if (options.onSuccess) {
          options.onSuccess(data)
        }
        localStorage.token = data.data.token
        localStorage.token_autoservicio = data.data.token_autoservicio
        localStorage.user = JSON.stringify(data.data.user)
      }, (err) => {
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  correo_recuperacion (options) {
    axios.post(uris.URL_FORGOT_PASSWORD, options.creds)
      .then((data) => {
        if (options.onSuccess) {
          options.onSuccess(data)
        }
        // localStorage.token = data.data.token
        // localStorage.token_autoservicio = data.data.token_autoservicio
        localStorage.mail = JSON.stringify(data.data.message)
      }, (err) => {
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  correo_change_pwd (options) {
    axios.post(uris.URL_CHANGE_PASSWORD, options.creds)
      .then((data) => {
        if (options.onSuccess) {
          options.onSuccess(data)
        }
        // localStorage.token = data.data.token
        // localStorage.token_autoservicio = data.data.token_autoservicio
        localStorage.user = JSON.stringify(data.data.user)
      }, (err) => {
        if (options.onError) {
          options.onError(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js